import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Contact, Category } from 'app/modules/contacts/contacts.types';
import { AccountService } from 'app/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Account } from 'app/core/models/account.types';
import { ContactsService } from 'app/modules/contacts/contacts.service';
import { MailboxService } from 'app/shared/components/widgets/mailbox-mail-list/services/mailbox.service';
import { UserService } from 'app/layout/common/user/user.service';
import Quill from 'quill';
import { MSWORD_MATCHERS, QUILL_MODULES } from 'app/shared/Utils/quill-editor.utils';

@Component({
  selector: 'contact-send-message',
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContactSendMessageComponent implements OnInit {
  sendMessageForm: UntypedFormGroup;
  copyFields: { cc: boolean; bcc: boolean };
  quill: Quill;
  quillModules = QUILL_MODULES;
  categories: Category[];
  contact: Contact;
  message: any;
  account: Account;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  visible = true;
  selectable = true;
  removable = true;

  private _unsubscribeAll: Subject<void>;

  toEmails: any[] = [];
  ccEmails: any[] = [];
  bccEmails: any[] = [];
  toTagCtrl: UntypedFormControl;
  ccTagCtrl: UntypedFormControl;
  bccTagCtrl: UntypedFormControl;

  /**
   * Constructor
   *
   * @param {MatDialogRef} matDialogRef
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ContactSendMessageComponent>,
    private _contactsService: ContactsService,
    private _mailboxService: MailboxService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _formBuilder: UntypedFormBuilder,
    private _accountService: AccountService,
    private _userService: UserService,
  ) {
    this.message = null;

    this._accountService.currentAccount.subscribe((accountData) => {
      this.account = accountData;
    });

    this._unsubscribeAll = new Subject();
    // Set the default
    this.copyFields = {
      cc: false,
      bcc: false,
    };

    this.toTagCtrl = new UntypedFormControl();
    this.ccTagCtrl = new UntypedFormControl();
    this.bccTagCtrl = new UntypedFormControl();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.sendMessageForm = this._formBuilder.group({
      subject: ['', [Validators.required]],
      body: [''],
      to: [[], [Validators.required]],
      cc: [[]],
      bcc: [[]],
    });
    this._userService.getUserSignature().subscribe((signature) => {
      this.sendMessageForm.patchValue({
        body: `<br /><br /><br /><br /><br />${signature}`,
      });
    });
    this._accountService.categories$.pipe(takeUntil(this._unsubscribeAll)).subscribe((categories: Category[]) => {
      if (categories) {
        this.categories = categories.filter((option) => !option.hidden);
      }

      // Mark for check
      this._changeDetectorRef.markForCheck();
    });

    this.contact = this.data.contact;
    //this.sendMessageForm.get('to').setValue([this.contact.email]);
    if (this.contact.email) {
      //this.addToEmail(this.contact.email);
      //this.toEmails.push(this.contact?.email)
      //this.sendMessageForm.get('to').patchValue(this.toEmails);
    }

    //this.toEmails.push(this.contact?.email)
    //this.sendMessageForm.get('to').disable()
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get the editor instance and add the MS Word matchers.
   */
  onEditorCreated(quill: Quill): void {
    this.quill = quill;
    const clipboard = this.quill.getModule('clipboard') as any;

    MSWORD_MATCHERS.forEach(([selector, matcher]) => {
      clipboard.addMatcher(selector, matcher);
    });
  }

  /**
   * Show the copy field with the given field name
   *
   * @param name
   */
  showCopyField(name: string): void {
    // Return, if the name is not one of the available names
    if (name !== 'cc' && name !== 'bcc') {
      return;
    }

    // Show the field
    this.copyFields[name] = true;
  }

  /**
   * Save and close
   */
  sendAndClose(): void {
    const message = this.sendMessageForm.getRawValue();
    // Update the contact on the server
    /*this._contactsService.sendMessage(this.contact.id, message.subject, message.body).subscribe(() => {
            // Close the dialog
            this.matDialogRef.close();
        }, (response) => {
          // Show the error message
          this.message = {
              appearance: 'outline',
              content   : response.error.message,
              showIcon  : false,
              type      : 'error'
          };
        });*/
    this._mailboxService
      .sendMail(parseInt(this.account.id), message.to, message.subject, message.body, message.cc, message.bcc)
      .subscribe(() => {
        this.matDialogRef.close();
      });
  }

  updateToEmails($event): void {}

  addToEmail($event): void {
    /*const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim())
        {
            this.toEmails.push(value.trim());
        }

        // Reset the input value
        if (input)
        {
            input.value = '';
        }

        this.toTagCtrl.setValue(null);
        this.sendMessageForm.get('to').patchValue(this.toEmails);*/
    this.toEmails = $event;
    this.sendMessageForm.get('to').patchValue(this.toEmails);
  }

  removeToEmail(tag: string): void {
    // Remove the tag
    this.toEmails.splice(
      this.toEmails.findIndex((item) => item === tag),
      1,
    );

    // Update the contact form
    this.sendMessageForm.get('to').patchValue(this.toEmails);
    this._changeDetectorRef.markForCheck();
  }

  addCCEmail($event): void {
    /*const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim())
        {
            this.ccEmails.push(value.trim());
        }

        // Reset the input value
        if (input)
        {
            input.value = '';
        }

        this.ccTagCtrl.setValue(null);
        this.sendMessageForm.get('cc').patchValue(this.ccEmails);*/

    this.ccEmails = $event;
    this.sendMessageForm.get('cc').patchValue(this.ccEmails);
  }

  removeCCEmail(tag: string): void {
    // Remove the tag
    this.ccEmails.splice(
      this.ccEmails.findIndex((item) => item === tag),
      1,
    );

    // Update the contact form
    this.sendMessageForm.get('cc').patchValue(this.ccEmails);
    this._changeDetectorRef.markForCheck();
  }

  addBCCEmail($event): void {
    /*const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim())
        {
            this.bccEmails.push(value.trim());
        }

        // Reset the input value
        if (input)
        {
            input.value = '';
        }

        this.bccTagCtrl.setValue(null);
        this.sendMessageForm.get('bcc').patchValue(this.bccEmails);*/
    this.bccEmails = $event;
    this.sendMessageForm.get('bcc').patchValue(this.bccEmails);
  }

  removeBCCEmail(tag: string): void {
    // Remove the tag
    this.bccEmails.splice(
      this.bccEmails.findIndex((item) => item === tag),
      1,
    );

    // Update the contact form
    this.sendMessageForm.get('bcc').patchValue(this.bccEmails);
    this._changeDetectorRef.markForCheck();
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Save the message as a draft
   */
  saveAsDraft(): void {}

  /**
   * Send the message
   */
  send(): void {}
}
